<!--
 * @Author: daipeng
 * @Date: 2019-09-06 11:50:03
 * @LastEditors: VSCode
 * @LastEditTime: 2019-09-12 17:01:13
 * @Description:
 -->
<template>
    <div :class="['comic-card', 'flex-row', { isMouseOver: isMouseOver, 'unshelve': comicData.onlineShowStatus === 0}]" @mouseover="isMouseOver = true" @mouseout="isMouseOver = false" style="min-width: 400px">
        <template v-if="showSelect">
            <div v-show="isMouseOver && !isSelected" class="select-box" @click="selectComicHandle(true)"></div>
            <div v-show="isSelected" class="select-box check" @click="selectComicHandle(false)"><i class="el-icon-check"></i></div>
        </template>
        <div class="comic-card-img" @click="previewComicInfo(comicData)">
            <img src="/static/space.gif" :key="$config.cdn + $utils.filterImagePath(comicData.comicCover34)" v-lazy="$config.cdn + $utils.filterImagePath(comicData.comicCover34)" alt="">
        </div>
        <dl class="comic-card-info">
            <dt class="flex-row-between">
                <div class="comic-card-title flex-row">
                    <el-tooltip class="item" effect="light" :content="comicData.comicName" placement="top-start">
                        <span class="comic-name" :title="comicData.comicName" style="max-width:90px;">{{comicData.comicName}}</span>
                    </el-tooltip>
                    <span class="comic-btn-edit comic-dispatch-primary cursor-pointer" @click="editComicHandle(comicData)"><i class="el-icon-edit"></i>编辑漫画</span>
                </div>
                <div v-if="comicData.onlineShowStatus === 0">已下架</div>
                <div v-else :class="comicData.auditStatus | auditStatusStyleFilter">
                    <!-- <span v-if="comicData.displayStatus != 2" class="mr10" :style="{color: comicData.displayStatus ? '#67c23a' : 'red'}">{{comicData.displayStatus === 0 ? '下架中' : '上架中'}}</span>
                    <span v-if="comicData.onlineShowStatus === -1" class="mr10" style="color:#67c23a">未上架</span>
                    <span v-else class="mr10" :style="{color: comicData.onlineShowStatus ? '#67c23a' : 'red'}">{{comicData.onlineShowStatus === 0 ? '已下架' : '已上架'}}</span> -->
                    {{comicData.auditStatus | auditStatusFilter}}
                    <el-tooltip effect="light" v-if="[-1, 3, 4].includes(comicData.auditStatus)" placement="top">
                        <div slot="content">{{comicData.auditRemark || (comicData.auditStatus === 3 ? '未通过' : '已通过')}}</div>
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>
            </dt>
            <dd>
                <span class="comic-dispatch-label">创建时间：</span>{{comicData.createTime | timeFilter('yyyy年MM月dd日 hh:mm')}}
            </dd>
            <dd>
                <span class="comic-dispatch-label">最新章节：</span>
                <span v-if="comicData.lastChapter" class="comic-dispatch-content">
                    {{comicData.lastChapter | chapterNameFilter}}
                </span>
                <span v-else class="comic-dispatch-content">
                    还没更新~
                </span>
                <el-button type="text" size="mini" plains @click="addChapter(comicData)">新增章节</el-button>
            </dd>
            <dd class="comic-card-btns">
                <el-button size="mini" plains type="primary" @click="managerChapter(comicData)">管理章节</el-button>
                <!-- 状态1、3 -> 待提交、未通过 显示提交按钮审核 -->
                <el-button v-if="[1,3,-1].indexOf(comicData.auditStatus) !== -1" size="mini" plains type="primary" @click="submitAudit(comicData)">提交审核</el-button>
                <el-button v-if="couldRemoveComic" size="mini" type="warning" @click="removeComicHandle">删除</el-button>
                <!-- <el-button size="mini" plain @click="setLabelHandler">标签设置</el-button> -->
            </dd>
        </dl>
    </div>
</template>
<script>
/*
 * @Author: daipeng
 * @Date: 2018-09-14 09:55:44
 * @LastEditors: OBKoro1
 * @LastEditTime: 2018-09-14 09:56:05
 * @Description: 漫画卡片
 * @Company: 成都二次元动漫
 */
import { mapState } from 'vuex';
export default {
    props: {
        comicData: {
            type: Object,
            default: () => {}
        },
        showSelect: { type: Boolean, default: false },
        // table list
        list: {
            type: Array,
            required: false,
            default: () => []
        },
        selectComicList: {
            type: Array,
            required: false,
            default: () => []
        },
        index: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            isMouseOver: false
        };
    },
    computed: {
        ...mapState('app', {
            level: state => state.userInfo.level // 1：用户 2：管理 3：超管 4:一审人员
        }),
        isSelected() {
            return this.selectComicList.includes(this.comicData);
        },
        couldRemoveComic() {
            // 普通CP账号 审核中的漫画隐藏“删除”按钮
            if (this.level === 1 && [0, 2].includes(this.comicData.auditStatus)) {
                return false;
            }
            return this.comicData.allowDelete === 1;
        }
    },
    methods: {
        // 选择漫画
        selectComicHandle(isSelected) {
            const that = this;
            if (isSelected) this.$emit('update:selectComicList', [...this.selectComicList, this.comicData]);
            else {
                const selectList = this.selectComicList.reduce((arr, obj) => {
                    if (obj !== that.comicData) arr.push(obj);
                    return arr;
                }, []);
                this.$emit('update:selectComicList', selectList);
            }
        },
        // 查看漫画详情
        previewComicInfo({comicId, comicName, authorName, uploaderUid, onlineShowStatus}) {
            // 如果下架中 则不能进入详情
            if (onlineShowStatus === 0) {
                return;
            }
            this.$router.push({ name: 'editComic', query: { comicId, comicName, authorName, uploaderUid, editType: 'view', tabtype: 1, single: true } });
        },
        // 编辑漫画
        editComicHandle({comicId, comicName, authorName, uploaderUid}) {
            this.$router.push({ name: 'editComic', query: { comicId, comicName, authorName, uploaderUid, editType: 'edit', tabtype: 1 } });
        },
        // 新增章节
        addChapter({comicId, comicName, authorName, uploaderUid, comicType}) {
            this.$router.push({ name: 'addChapter', query: { comicId, comicName, authorName, uploaderUid, editType: 'add', comicType } });
        },
        // 章节管理
        managerChapter({comicId, comicName, authorName, uploaderUid, comicType}) {
            this.$router.push({ name: 'editComic', query: { comicId, comicName, authorName, uploaderUid, editType: 'edit', tabtype: 2, comicType } });
        },
        // 提交审核
        submitAudit({ comicId, comicName, authorName }) {
            this.$utils.confirm('', '确认提交审核吗？', '提交中...', (action, instance, done) => {
                return this.$api('submitaudit', { comicId, comicName, authorName }).then(res => {
                    // 更新当前漫画卡片，因为卡片是数组项，所以需要更新数组
                    let _data = this.$utils.cloneDeep(this.list);
                    _data.splice(this.index, 1, { ...this.comicData, auditStatus: 0 });
                    this.$emit('update:list', _data);
                });
            });
        },
        // 删除漫画
        removeComicHandle() {
            const { comicId, comicName, authorName } = this.comicData;
            this.$utils.confirm('', '确定删除该漫画吗？', '删除中...', (action, instance, done) => {
                return this.$api('removeComic', { comicId, comicName, authorName }).then(res => {
                    this.$parent.getTableList();
                });
            });
        },
        // 标签设置
        setLabelHandler() {
            const { comicId, comicName } = this.comicData;
            this.$router.push({ name: 'labelSetting', query: { comicId, comicName } });
        }
    }
};
</script>
<style lang="scss">
    .comic-card{
        position: relative;
        width: calc(50% - 10px);
        min-width: 560px;
        margin-right: 20px;
        width: 560px;
        height: 160px;
        background-color: #fff;
        border: 1px solid #e4e7ea;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 2px;
        margin-bottom: 20px;
        &.unshelve {
           filter: grayscale(1);
           .comic-card-info {
               position: relative;
               &:after {
                   content: '';
                   position:absolute;
                   left: 0;
                   right: 0;
                   top: 0;
                   bottom: 0;
                   cursor:not-allowed;
               }
           }
        }
        &.isMouseOver{
            box-shadow: 0px 0px 20px rgba(102, 102, 102, 0.35);
        }
        &-img{
            position: relative;
            width: 140px;
            height: 100%;
            background-color: #e4e7ea;
            border-right: 1px solid #e4e7ea;
            cursor: pointer;
            img{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
        }
        &-info{
            padding: 10px;
            flex-grow: 1;
            font-size: 14px;
            dt, dd {
                height: 30px;
                line-height: 30px;
                color: #606266;
            }
            .comic-name{
                max-width: 140px;
                font-size: 16px;
                font-weight: bold;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        &-title{
            align-items: center;
        }
        &-btns{
            font-size: 0;
            margin: 10px 0 0 0;
            .el-button{
                padding: 7px 10px;
            }
        }
        .comic-btn-edit{
            font-size: 12px;
            margin-left: 10px;
        }
        .select-box{
            position: absolute;
            top: -1px;
            left: -1px;
            width: 40px;
            height: 40px;
            z-index: 50;
            cursor: pointer;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(233, 233, 233, 1);
            &.check{
                background: rgba(24, 144, 255, 1);
                border: none;
                i{
                    color: #fff;
                    font-size: 24px;
                    margin: 8px;
                }
            }
        }
    }
</style>
